<template>
  <div class="row mt-2 mb-2 p-2 ">
    <div class="col-12 col-sm-6  col-md-3 col-lg-3 ">
      <div class="text-center">
        <img :src="image_url+offer.developer.avatar" alt="avatar" class="p-3 img-fluid col-7 col-sm-7 col-md-9 rounded-circle">
        <p>    <router-link   tag="a"
            :to="{name: 'user_page_main', params: { user_id: offer.developer.last_id }}" >{{ offer.developer.name }}</router-link></p>
        <p>    <router-link   tag="a" class="btn"
            :to="{name: 'user_page_portfolio', params: { user_id: offer.developer.last_id }}" >портфолио</router-link></p>
      </div>

    </div>

    <div class="col-12 col-sm-6 col-md-9 col-lg-9 ">
      <div class="text-center">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-6">
          <p><i class="fa fa-calendar-times-o"></i> {{ offer.created_at}}</p>
          <p>сроки - <i class="fa fa-calendar-times-o"></i>{{ offer.date_end }}</p>
        </div>
        <div class="col-12 col-sm-12 col-md-6">
          <p>{{ offer.price }} {{ offer.currency }}</p>
          <div v-if="offer.prepaid_price>0" class="alert alert-danger">
            <p>предоплата {{ offer.prepaid_price }} {{ offer.currency }}</p>
          </div>
          <p v-if="(!offer.type) || (offer.type && offer.type=='one')">оплата единоразовая</p>
          <p v-if="(offer.type && offer.type=='every_month')">оплата раз в месяц</p>
          <p v-if="(offer.type && offer.type=='every_year')">оплата раз в год</p>
        </div>
      </div>


      <p>{{ offer.comment }}</p>





      <button v-if="isDeveloper" class="btn btn-red" @click="clickEdit">Отредактировать</button>
      <button v-if="isClient" class="btn " @click="clickChoose">Выбрать<br> исполнителя</button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: 'FreelanceBlock',
  props: {
    offer:Object,

    isClient:Boolean,
    isDeveloper:Boolean

  },
  data(){
    return {
      'image_url':""
    };
  },
  mounted() {
    var app=this;

    app.image_url = Vue.config.IMAGE_URL;

  },
  methods:{
    clickEdit(){
      return this.$emit("click_developer",1);
    },
    clickChoose(){
      return this.$emit('click_choose_developer',1);
    }
  }
}
</script>

<style scoped>



</style>
